import { Controller } from "@hotwired/stimulus";

import Dropzone from "dropzone";

export default class extends Controller {
  initialize() {
    console.log("pic-dropzone init");
    Dropzone.autoDiscover = false;
  }

  connect() {
    var message =
      "<div class='fs-4 fw-bold'>Drop an <u>Image File</u> here</div>" +
      "<div class='btn btn-primary my-3 d-block fs-5'>Click to Browse</div>" +
      "<ul class='rounded list-group list-group-flush border border-info'>" +
      "<li class='list-group-item list-group-item-primary'>PNG, GIF, JPG</li>" +
      "<li class='list-group-item list-group-item-primary'>Less than 12MB</li></ul>";

    $("#fileInput").dropzone({
      url: $("#airplay_picture_upload").attr("action"),
      maxFiles: 1,
      maxFilesize: 12_000_000,
      paramName: "airplay_picture[picture]",
      addRemoveLinks: true,
      withCredentials: true,
      headers: { "X-FORWARDED-HOST": window.location.host },
      dictDefaultMessage: message,
      acceptedFiles: ".png,.gif,.jpg,.jpeg,image/jpeg,image/gif,image/png",
      error: function (file, message) {
        console.log("DJ error:", message);
        $(file.previewElement)
          .addClass("dz-error")
          .find(".dz-error-message")
          .text(message)
          .css({ opacity: 1 });
      },
      sending: function (file, xhr, formData) {
        $(
          "#airplay_picture_upload input[type=hidden],#airplay_picture_upload input[type=url]"
        ).each(function (i, e) {
          formData.append($(e).attr("name"), $(e).val());
        });
      },
      success: function (file, json) {
        //    onward.picture = true;
        $(file.previewElement).text(json.message);
        if (json.next_url) {
          setTimeout(function () {
            Turbo.visit(json.next_url);
          }, 3000);
        }

        //    check();
      },
    });

    this.dz = $("#fileInput").get(0).dropzone;
  }

  disconnect() {
    this.dz.destroy();
  }
}
